import { createFileRoute } from '@tanstack/react-router';

import { DataSyncPage } from '@apps/web/routes/_app/admin/data_sync_page';

export const Route = createFileRoute('/_app/admin/data-sync')({
    component: DataSyncPage,
    head: () => ({
        meta: [
            {
                title: 'Data Sync | Phoebe Admin',
            },
        ],
    }),
});
